import {
    Flex,
    Label,
    Select,
} from '@bamboohr/fabric';
import { FilingStatus } from './types';

/**
 * Props for the FilingStatusSelect component
 */
export type FilingStatusSelectProps = {
    /** options for the select dropdown */
    filingStatusOptions: FilingStatus[];
    /** determines how the field should be rendered and whether the field should be ignored by the form */
    ignore: boolean;
    /** event handler for filing status onChange */
    onFilingStatusChange: (value: string) => void;
    /** the selected filing status */
    selectedFilingStatus: FilingStatus | null;
    /** determines whether a field is view-only */
    viewOnly: boolean;
};

/**
 * FilingStatusSelect Component
 * 
 * A component that renders a select dropdown for choosing a filing status
 * for state tax withholding.
 */
export const FilingStatusSelect = ({
    filingStatusOptions,
    selectedFilingStatus,
    ignore,
    viewOnly,
    onFilingStatusChange,
}: FilingStatusSelectProps) => {
    return (
        <Flex flexDirection="column">
            <Label 
                disabled={ ignore || viewOnly } 
                htmlFor="stateStatus" 
                required={ !ignore }
            >
                { $.__('Filing Status') }
            </Label>
            <Select
                id="stateStatus"
                isClearable={ true }
                isDisabled={ ignore || viewOnly }
                items={
                    filingStatusOptions.map((status) => {
                        return {
                            text: ignore ? 'NA' : status.displayText,
                            value: status.val,
                        };
                    })
                }
                name="state[status]"
                onChange={ (value: string[]) => {
                    onFilingStatusChange(value[0]);
                } }
                placeholder={ ignore ? 'NA' : undefined }
                required={ !ignore }
                selectedValues={ selectedFilingStatus ? [selectedFilingStatus.val] : [] }
                width={ 8 }
            />
        </Flex>
    );
};